/**
 * Keeps the benefits-strip marquee at a constant on-screen speed.
 *
 * The CSS animation moves each list by one list-width per loop, so the loop
 * duration has to follow the rendered width: width / --benefits-marquee-speed
 * (px per second, set per breakpoint in benefits-strip.liquid).
 */
class BenefitsMarquee extends HTMLElement {
  /** @type {ResizeObserver | null} */
  #observer = null;

  connectedCallback() {
    const list = this.querySelector('.benefits-strip__list');
    if (!list) return;

    this.#observer = new ResizeObserver(() => this.#updateDuration(list));
    this.#observer.observe(list);
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  /**
   * @param {Element} list
   */
  #updateDuration(list) {
    const width = list.getBoundingClientRect().width;
    const speed = parseFloat(getComputedStyle(this).getPropertyValue('--benefits-marquee-speed'));
    if (!width || !speed) return;

    this.style.setProperty('--benefits-marquee-duration', `${(width / speed).toFixed(2)}s`);
  }
}

if (!customElements.get('benefits-marquee')) {
  customElements.define('benefits-marquee', BenefitsMarquee);
}
